import {
  DEFAULT_NA,
  PROFILE_SUBNAME,
} from '../newrelic-constants';

import {
  getEnvironmentMicro,
} from '../newrelic-helpers';

export function nrRecoverAccount(globalState, actionName, fullStory, metricData) {
  const errorCode = metricData?.action?.errorCode || DEFAULT_NA;
  const resultState = metricData?.resultState || DEFAULT_NA;

  const data = {
    actionSubname: PROFILE_SUBNAME.WEBRECOVERACCOUNT,
    entryPoint: 'Modal Login',
    environment: getEnvironmentMicro(),
    errorCode,
    flow: 'MYB',
    fullstory: fullStory || '*',
    resultState,
    storefront: metricData?.storefront,
    subflow: 'ancillary',
    url: window.location.href,
  };

  window.newrelic.addPageAction(actionName, data);
}